import { Platform } from "react-native";

export const loginDefaultFontSize = Platform.OS == 'web' ? 18 : 14;

export const TextValidationMsgSize = Platform.OS == 'web' ? 14 : 12;
export const TextSmallSize = Platform.OS == 'web' ? 14 : 13;
export const TextdefaultSize = Platform.OS == 'web' ? 16 : 14;
export const TextMediumSize = Platform.OS == 'web' ? 18 : 16;
export const TextMediumLargeSize = Platform.OS == 'web' ? 20 : 18;
export const TextLargeSize = Platform.OS == 'web' ? 24 : 22;
export const TextExtraLargeSize = Platform.OS == 'web' ? 28 : 24;
